import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Collections.css";

const Collections = () => {
  const navigate = useNavigate();

  const collections = [
    { 
      id: "moments-of-love",
      name: "Moments of Love", 
      description: "A collection for those who cherish slow mornings, heartfelt gifts, and cozy moments.", 
      image: "/images/collections/couples_collection.png" 
    },
    // { 
    //   id: "nordic-calm",
    //   name: "Nordic Calm", 
    //   description: "Inspired by Scandinavian simplicity, with soft tones and clean lines that bring calm to your space.", 
    //   image: "/images/collections/nordic_calm.png" 
    // },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatically switch every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % collections.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [collections.length]);

  const current = collections[currentIndex];

  return (
    <div className="Collections_Test">
    <div
      className="Collections"
      style={{
        backgroundImage: `url(${current.image})`,
        cursor: "pointer" // indicates it’s clickable
      }}
      onClick={() => navigate(`/collection/${current.id}`)}
    >
      <div className="Collection_Content">
        <h2>{current.name}</h2>
        <p>{current.description}</p>
      </div>
    </div>
    </div>
  );
};

export default Collections;
